import React from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { Layout } from '../atoms-types/layout';
import { PaceOfPlayChart } from '../charts-graphs/paceOfPlayChart';
import { PaceOfPlayChart2 } from '../charts-graphs/paceOfPlayChart2';

const ResponsiveGridLayout = WidthProvider(Responsive);

const PaceOfPlayGrid: React.FC = () => {

  const layout: Layout[] = [
    { i: 'a', x: 2, y: 3, w: 9, h: 10, minW: 1, minH: 7 },
  ];

  return (
    <ResponsiveGridLayout 
      className="layout" 
      layouts={{ lg: layout }} 
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }} 
      cols={{ lg: 3, md: 3, sm: 3, xs: 1 }}
      rowHeight={100}
      draggableCancel=".cancelSelectorName"
      isDraggable={false}
      isResizable={false}
      >
      <div key="a" style={{ minHeight: "700px" }} className='card-gauge'>
        <PaceOfPlayChart2 />
      </div>
    </ResponsiveGridLayout>
  );
};

export default PaceOfPlayGrid;